module.exports = {"140825100":"龙兴镇","140825101":"三泉镇","140825102":"泽掌镇","140825103":"北张镇","140825104":"古交镇","140825105":"万安镇","140825106":"阳王镇","140825107":"泉掌镇","140825200":"横桥乡","140825400":"社区办","140825498":"新绛县煤化园区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140825.json
// module id = 297
// module chunks = 0